/* src/app/components/payroll/timesheets/timesheet-goodtopay-list/timesheet-goodtopay-list.component.css */
.table-style {
  width: 100%;
}
.error-message {
  color: red;
  font-size: 12px;
  margin-bottom: 4px;
  display: block;
}
.error-message1 {
  color: red;
  font-size: 12px;
  margin-bottom: 4px;
}
.ant-select {
  margin-bottom: 0px !important;
}
.field-header {
  font-size: 12px;
}
.ant-form-item {
  margin-bottom: 10px !important;
}
/*# sourceMappingURL=timesheet-goodtopay-list.component-OGEVSNI2.css.map */
